function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var PostMessageEventBus = /*#__PURE__*/function () {
  function PostMessageEventBus(current, target) {
    var _this = this;
    _classCallCheck(this, PostMessageEventBus);
    _defineProperty(this, "current", void 0);
    _defineProperty(this, "target", void 0);
    _defineProperty(this, "events", {});
    this.current = current;
    this.target = target;
    this.current.addEventListener('message', function (e) {
      var _e$data;
      var event = (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.event;
      if (_this.events[event]) {
        _this.events[event].forEach(function (cb) {
          return cb(e.data.payload);
        });
      }
    });
  }
  _createClass(PostMessageEventBus, [{
    key: "on",
    value: function on(event, callback) {
      this.events[event] = this.events[event] || [];
      this.events[event].push(callback);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event, payload) {
      this.target.postMessage({
        event: event,
        payload: payload
      }, '*');
      return this;
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      var cbs = this.events[event];
      if (!cbs) return this;
      if (!callback) {
        this.events[event] = [];
        return this;
      }
      var index = cbs.indexOf(callback);
      if (index > -1) {
        delete cbs[index];
      }
      return this;
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      var _this2 = this;
      var cb = function cb() {
        callback.apply(void 0, arguments);
        _this2.off(event, cb);
      };
      this.on(event, cb);
      return this;
    }
  }]);
  return PostMessageEventBus;
}();
export default PostMessageEventBus;